// 前台商城--登录
export const xbLogin = 'XB_LOGIN'
// 前台商城--用户信息
export const xbUserInfo = 'XB_USER_INFO'
// 前台商城--登录状态
export const xbLoginStatus = 'XB_LOGIN_STATUS'

// 后台CMS--登录
export const dbLogin = 'DB_LOGIN'
// 后台CMS--用户信息
export const dbUserInfo = 'DB_USER_INFO'
// 后台CMS--登录状态
export const dbLoginStatus = 'DB_LOGIN_STATUS'
